import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <SectionHeading
          kicker="主题分类"
          title="按追踪阶段归档，找线索不靠翻"
          desc="同一件事在不同阶段会有完全不同的信息密度。我们按线索的成熟度分成四类，你可以直接跳到最关心的一类。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/news?category=${encodeURIComponent(cat.id)}`}
              className="group flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <h3 className="mb-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                {cat.name}
              </h3>
              <p className="mb-5 flex-1 text-sm leading-relaxed text-foreground-600">
                {cat.desc}
              </p>
              <span className="flex items-center justify-between border-t border-background-200 pt-3 font-label text-xs text-foreground-500">
                <span>{cat.count} 条记录</span>
                <i className="ri-arrow-right-up-line text-base transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}